import { Fragment, useLayoutEffect } from 'react';
import { IView } from '../../views/view';
import useNavigation from '../../hooks/useNavigation';

interface IRedirectToView {
  view: IView;
}

const RedirectToView = ({ view }: IRedirectToView) => {
  const navigation = useNavigation();

  useLayoutEffect(() => {
    if (!view) {
      return;
    }
    navigation.replace(view);
  }, [navigation, view]);

  return <Fragment />;
};

export default RedirectToView;
